/* ============================================================
   Living Juice — Routine Builder (finder + explore + builder)
   ------------------------------------------------------------
   Reads everything from window.LJ_CONFIG, which the Liquid
   section (sections/lj-routine-builder.liquid) prints from the
   merchant-selected Shopify collection + product metafields.

   If window.LJ_CONFIG.products is empty (e.g. the collection
   isn't wired up yet) it falls back to DEMO_PRODUCTS so the
   section still renders in the theme editor.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- CONFIG (printed by the Liquid section) ---------- */
  var CFG = window.LJ_CONFIG || {};

  /* Demo fallback — mirrors the prototype so the section is never blank.
     Ignored once the collection + metafields are populated. */
  /* subPrice/oncePrice below just approximate 20%/10% off for the DEMO
     preview only — the real page never computes these, it reads them
     straight from Shopify's variant.selling_plan_allocations (see
     lj-routine-builder.liquid), so the real % always matches whatever
     is actually configured in Recharge. */
  var DEMO_PRODUCTS = [
    {id:'gv12', variantId:'', name:'Green Vitality', size:'12oz Juice', price:9.00, subPrice:7.20, oncePrice:8.10, color:'#7bab45', ingr:'Kale, cucumber, lemon, celery, fennel, parsley', goals:['energy','cleanse'], tags:['Energy','Greens']},
    {id:'gv4',  variantId:'', name:'Green Vitality', size:'4oz Mini',   price:5.00, subPrice:4.00, oncePrice:4.50, color:'#7bab45', ingr:'Kale, cucumber, lemon, celery, fennel, parsley', goals:['energy','cleanse'], tags:['Energy','On-the-go']},
    {id:'fs12', variantId:'', name:'Fresh Start',    size:'12oz Juice', price:9.00, subPrice:7.20, oncePrice:8.10, color:'#eaa93d', ingr:'Lemon, apple, ginger', goals:['cleanse','immunity'], tags:['Digest','Zesty']},
    {id:'rr12', variantId:'', name:'Red Radiance',   size:'12oz Juice', price:9.00, subPrice:7.20, oncePrice:8.10, color:'#d1495b', ingr:'Strawberry, beet, apple', goals:['recovery','energy'], tags:['Recovery','Glow']},
    {id:'ck12', variantId:'', name:'Carrot Kick',    size:'12oz Juice', price:9.00, subPrice:7.20, oncePrice:8.10, color:'#eaa93d', ingr:'Carrot, orange, yellow beet', goals:['immunity','recovery'], tags:['Immunity','Vitamin C']},
    {id:'ck4',  variantId:'', name:'Carrot Kick',    size:'4oz Mini',   price:5.00, subPrice:4.00, oncePrice:4.50, color:'#eaa93d', ingr:'Carrot, orange, yellow beet', goals:['immunity','recovery'], tags:['Immunity','On-the-go']},
    {id:'wm12', variantId:'', name:'Watermelon Mint',size:'12oz · Limited', price:8.00, subPrice:6.40, oncePrice:7.20, color:'#e05b7a', ingr:'Watermelon, mint, lime', goals:['refresh','cleanse'], tags:['Hydrate','Refresh']},
    {id:'she',  variantId:'', name:'Energy+ Shot',   size:'Wellness Shot', price:4.50, subPrice:3.60, oncePrice:4.05, color:'#8a5cd6', ingr:'Ginger, turmeric, cayenne, citrus', goals:['energy'], tags:['Energy','Daily boost']},
    {id:'shi',  variantId:'', name:'Immunity+ Shot', size:'Wellness Shot', price:4.50, subPrice:3.60, oncePrice:4.05, color:'#8a5cd6', ingr:'Ginger, turmeric, orange, cayenne', goals:['immunity'], tags:['Immunity','Daily defence']},
    {id:'shr',  variantId:'', name:'Recovery+ Shot', size:'Wellness Shot', price:4.50, subPrice:3.60, oncePrice:4.05, color:'#8a5cd6', ingr:'Beet, ginger, lemon, cayenne', goals:['recovery'], tags:['Recovery','Post-workout']}
  ];

  var PRODUCTS = (CFG.products && CFG.products.length) ? CFG.products : DEMO_PRODUCTS;

  var GOALS = CFG.goals || [
    {id:'all',      label:'All products',     ic:'🧺'},
    {id:'energy',   label:'Energy',           ic:'⚡'},
    {id:'immunity', label:'Immunity',         ic:'🛡️'},
    {id:'recovery', label:'Recovery',         ic:'💪'},
    {id:'cleanse',  label:'Cleanse & digest', ic:'🌿'},
    {id:'refresh',  label:'Refresh',          ic:'💧'}
  ];

  /* size groups — MUST match the metafield "size group" values.
     Merchant maps each product's size label to one of these keys. */
  var SIZE_GROUPS = CFG.sizeGroups || {
    any:   null,
    juice: ['12oz Juice','12oz · Limited'],
    mini:  ['4oz Mini'],
    shot:  ['Wellness Shot']
  };

  var STEPS = CFG.steps || [
    {key:'juice', short:'12oz Juices',     sub:'Full-size',   title:'Pick your 12oz juices',
      blurb:'The foundation of your routine — full-size cold-pressed juices, 6–9 servings of produce each.',
      sizes:SIZE_GROUPS.juice, next:'Next: on-the-go minis &rarr;'},
    {key:'mini',  short:'On-the-go minis', sub:'4oz',         title:'Add your on-the-go minis',
      blurb:'4oz minis — a concentrated hit that fits a bag, a desk drawer or a busy morning.',
      sizes:SIZE_GROUPS.mini,  next:'Next: wellness shots &rarr;'},
    {key:'shot',  short:'Wellness Shots',  sub:'Functional',  title:'Top it off with Wellness Shots',
      blurb:'Functional shots that target energy, immunity and recovery — one quick daily ritual.',
      sizes:SIZE_GROUPS.shot,  next:'Review your box &rarr;'}
  ];

  var EX_INFO = CFG.exInfo || {
    juice:{title:'Full-size 12oz Juices',    desc:'The foundation of a routine — 6–9 servings of organic produce pressed into every 12oz bottle.'},
    mini: {title:'On-the-go 4oz Minis',      desc:'A concentrated produce hit that fits a bag or a desk drawer. The same cold-pressed juice, pocket-sized.'},
    shot: {title:'Functional Wellness Shots',desc:'Targeted ginger, turmeric and citrus shots for energy, immunity and recovery.'}
  };

  var STARTERS = CFG.starters || [];

  var MIN_ITEMS = CFG.minItems || 6;

  /* ---------- STATE ---------- */
  var cart = {};        // id -> qty
  var mode = 'sub';
  var currentStep = 0;
  var buildMode = 'goal';
  var activeGoal = 'all';
  var finderSize = 'any';
  var exCat = 'juice';

  function $(id){ return document.getElementById(id); }
  /* String(...) on both sides on purpose: cart{} keys (via Object.keys /
     for...in) are always strings, but product ids coming from Liquid can
     be numbers if a template ever pipes a numeric value straight through
     | json without forcing it to a string first. A strict === between
     "123" and 123 silently fails — the product card still shows the
     right quantity (bracket access coerces fine either way) while every
     total/summary/checkout computation quietly sees nothing. Comparing
     as strings here makes that whole bug class impossible regardless of
     what shape the Liquid side sends. */
  function byId(id){
    var key = String(id);
    return PRODUCTS.filter(function(p){ return String(p.id) === key; })[0];
  }
  /* Real per-unit price for whichever mode is active — sourced from
     Shopify's own selling-plan pricing (see lj-routine-builder.liquid),
     never computed from a hardcoded %. Falls back to the regular price
     if that product has no matching plan attached yet. */
  function unitPrice(p){
    if (mode === 'sub') return (p.subPrice != null) ? p.subPrice : p.price;
    return (p.oncePrice != null) ? p.oncePrice : p.price;
  }
  function planIdFor(p){
    return mode === 'sub' ? p.sellingPlanId : p.onceSellingPlanId;
  }
  /* Per-product discount for whichever mode is active — computed fresh
     from real prices every render, never a fixed %. pct is 0 (and was/now
     the same) whenever that product has no plan attached yet, so cards
     just show a plain price with no "Save" badge until Recharge is wired
     up for that specific product. */
  function discountInfo(p){
    var now = unitPrice(p);
    var was = p.price;
    var pct = (was > 0 && now < was) ? Math.round((1 - (now / was)) * 100) : 0;
    return { now: now, was: was, pct: pct };
  }
  /* Card media: a real product photo when Shopify has one (p.image),
     otherwise the original illustrative colour swatch/bottle — never both. */
  function cardMediaHtml(p){
    if (p.image) return '<img src="'+p.image+'" alt="'+p.name+'" loading="lazy">';
    return '';
  }
  function priceHtml(p){
    var d = discountInfo(p);
    if (d.pct <= 0) return '<div class="price-wrap"><span class="price">$'+d.now.toFixed(2)+'</span></div>';
    return '<div class="price-wrap">'+
             '<span class="price-was">$'+d.was.toFixed(2)+'</span>'+
             '<span class="price">$'+d.now.toFixed(2)+'</span>'+
             '<span class="save-badge">Save '+d.pct+'%</span>'+
           '</div>';
  }

  /* ---------- BUILD-MODE SWITCH ---------- */
  function setBuildMode(m){
    buildMode = m;
    var btns = document.querySelectorAll('#buildswitch button');
    for (var i=0;i<btns.length;i++){ btns[i].classList.toggle('on', btns[i].dataset.build===m); }
    $('typeView').style.display = m==='type' ? '' : 'none';
    $('goalView').style.display = m==='goal' ? '' : 'none';
    $('stepFoot').style.display = m==='type' ? '' : 'none';
    if (m==='type') renderStep(); else { renderGoals(); renderGrid(); }
  }
  var buildswitch = $('buildswitch');
  if (buildswitch) buildswitch.addEventListener('click', function(e){
    var b = e.target.closest('button'); if(!b) return;
    setBuildMode(b.dataset.build);
  });

  /* ---------- GOALS (build-by-goal) ---------- */
  var goalbar = $('goalbar');
  /* Renders BOTH a normal-state and active-state icon (image or emoji
     fallback) inside every chip; CSS shows/hides them based on the
     chip's .active class, so no re-render is needed on click. */
  function goalIconHtml(g){
    var def = g.icon ? '<img src="'+g.icon+'" alt="" loading="lazy">' : (g.ic || '');
    var act = g.iconActive ? '<img src="'+g.iconActive+'" alt="" loading="lazy">' : def;
    return '<span class="ic-default">'+def+'</span><span class="ic-active">'+act+'</span>';
  }
  function renderGoals(){
    if(!goalbar) return;
    goalbar.innerHTML='';
    GOALS.forEach(function(g){
      var b=document.createElement('button');
      b.className='goal-chip'+(g.id===activeGoal?' active':'');
      b.innerHTML='<span class="ic">'+goalIconHtml(g)+'</span>'+g.label;
      b.onclick=function(){ activeGoal=g.id; finderSize='any'; renderGoals(); renderGrid(); updateGoalNote(); };
      goalbar.appendChild(b);
    });
    updateGoalNote();
  }
  function updateGoalNote(){
    var note=$('goalNote'); if(!note) return;
    var map=CFG.goalNotes || {
      all:'Showing all products. Tap a goal to see what fits.',
      energy:'Energising greens, beet-based blends and our Energy+ shot to power your day.',
      immunity:'Vitamin-C rich blends and our Immunity+ shot for daily defence.',
      recovery:'Antioxidant-rich reds and our Recovery+ shot to bounce back.',
      cleanse:'Light, digestive blends with lemon, ginger and greens.',
      refresh:'Hydrating, refreshing sips for warm days.'
    };
    var sizeLbl={any:'',juice:'full-size juices only',mini:'minis only',shot:'shots only'};
    if(finderSize!=='any'){
      note.innerHTML=(map[activeGoal]||'')+' &nbsp;<b style="color:var(--green-2)">'+sizeLbl[finderSize]+'</b> · <a href="#" id="clearSize" style="color:var(--lime-dark);font-weight:700">clear</a>';
      $('clearSize').onclick=function(e){e.preventDefault();finderSize='any';renderGrid();updateGoalNote();};
    } else {
      note.textContent=map[activeGoal]||'';
    }
  }

  /* ---------- STEP NAV / STEPS ---------- */
  function stepCount(i){
    var sizes=STEPS[i].sizes, n=0;
    for(var id in cart){ var p=byId(id); if(p && sizes.indexOf(p.size)>-1) n+=cart[id]; }
    return n;
  }
  var stepnav=$('stepnav');
  function renderStepNav(){
    if(!stepnav) return;
    stepnav.innerHTML='';
    STEPS.forEach(function(s,i){
      var b=document.createElement('button');
      var c=stepCount(i);
      b.className='stepnav-item'+(i===currentStep?' active':'')+(c>0&&i!==currentStep?' done':'');
      b.innerHTML='<i>'+(i+1)+'</i><span><b>'+s.short+'</b><small>'+s.sub+'</small></span><span class="cnt'+(c>0?' show':'')+'">'+c+'</span>';
      b.onclick=function(){ currentStep=i; renderStep(); };
      stepnav.appendChild(b);
    });
  }
  function renderStep(){
    renderStepNav();
    var s=STEPS[currentStep];
    $('stepHead').innerHTML='<h3>'+s.title+'</h3><p>'+s.blurb+'</p>';
    var back=$('stepBack'), next=$('stepNext');
    back.disabled = currentStep===0;
    if(currentStep < STEPS.length-1){
      next.innerHTML=s.next;
      next.onclick=function(){ currentStep++; renderStep(); window.scrollTo({top:$('builder').offsetTop-70,behavior:'smooth'}); };
    } else {
      next.innerHTML='Review your box &rarr;';
      next.onclick=function(){ document.querySelector('.summary').scrollIntoView({behavior:'smooth',block:'center'}); };
    }
    back.onclick=function(){ if(currentStep>0){ currentStep--; renderStep(); } };
    renderGrid();
  }

  /* ---------- STARTERS ---------- */
  var startersEl=$('starters');
  if(startersEl && STARTERS.length){
    STARTERS.forEach(function(s){
      var d=document.createElement('div');
      d.className='starter';
      d.innerHTML='<b>'+s.name+'</b><small>'+s.desc+'</small>';
      d.onclick=function(){ cart=Object.assign({},s.items); currentStep=0; if(buildMode==='type')renderStep(); else renderGrid(); renderExplore(); renderSummary(); $('builder').scrollIntoView({behavior:'smooth'}); };
      startersEl.appendChild(d);
    });
  }

  /* ---------- shared add / stepper ---------- */
  function fillCtrl(ctrl,id){
    var qty=cart[id]||0; ctrl.innerHTML='';
    if(qty>0){
      var s=document.createElement('div'); s.className='stepper';
      s.innerHTML='<button aria-label="minus">−</button><span class="qty">'+qty+'</span><button aria-label="plus">+</button>';
      s.children[0].onclick=function(){ setQty(id,qty-1); };
      s.children[2].onclick=function(){ setQty(id,qty+1); };
      ctrl.appendChild(s);
    } else {
      var a=document.createElement('button'); a.className='add-btn'; a.textContent='Add';
      a.onclick=function(){ setQty(id,1); };
      ctrl.appendChild(a);
    }
  }

  /* ---------- GRID ---------- */
  var grid=$('prodGrid');
  /* Case/whitespace-insensitive goal match — merchants type metafield
     values by hand (Shopify admin), so "Refresh", " refresh ", "REFRESH"
     must all match the "refresh" goal chip. Also tolerates p.goals being
     either a real array (list metafield) or a comma-separated string
     (single-line metafield), matching the same defensive handling used
     for ingredients elsewhere in this file. */
  function hasGoal(p, goal){
    if (goal === 'all') return true;
    if (!p.goals) return false;
    var list = Array.isArray(p.goals) ? p.goals : String(p.goals).split(',');
    for (var i=0;i<list.length;i++){
      if (String(list[i]).trim().toLowerCase() === goal.toLowerCase()) return true;
    }
    return false;
  }
  function renderGrid(){
    if(!grid) return;
    grid.innerHTML='';
    var list;
    if(buildMode==='type'){
      list = PRODUCTS.filter(function(p){ return STEPS[currentStep].sizes.indexOf(p.size)>-1; });
    } else {
      var sg = SIZE_GROUPS[finderSize];
      list = PRODUCTS.filter(function(p){ return hasGoal(p, activeGoal) && (!sg || sg.indexOf(p.size)>-1); });
    }
    if(!list.length){ grid.innerHTML='<div class="cart-empty" style="grid-column:1/-1">No products match that combination — try clearing a filter.</div>'; return; }
    list.forEach(function(p){
      var qty=cart[p.id]||0;
      var el=document.createElement('div');
      el.className='prod'+(qty>0?' in':'');
      var swatchClass='swatch'+(p.image?' has-photo':'');
      var swatchStyle=p.image?'':' style="background:linear-gradient(180deg,'+p.color+',#333)"';
      el.innerHTML='<div class="prod-top"><div class="'+swatchClass+'"'+swatchStyle+'>'+cardMediaHtml(p)+'</div>'+
        '<div><h4>'+p.name+'</h4><span class="size-pill">'+p.size+'</span></div></div>'+
        '<div class="ingr">'+p.ingr+'</div>'+
        '<div class="tags">'+(p.tags||[]).map(function(t){return '<span class="tag">'+t+'</span>';}).join('')+'</div>'+
        '<div class="prod-bot">'+priceHtml(p)+'<div class="ctrl"></div></div>';
      fillCtrl(el.querySelector('.ctrl'),p.id);
      grid.appendChild(el);
    });
  }
  function setQty(id,q){
    if(q<=0) delete cart[id]; else cart[id]=q;
    renderGrid(); if(buildMode==='type') renderStepNav(); renderExplore(); renderSummary();
  }

  /* ---------- EXPLORE (slider) ---------- */
  var exTrack=$('exTrack');
  function renderExplore(){
    if(!exTrack) return;
    exTrack.innerHTML='';
    var sg=SIZE_GROUPS[exCat]||[];
    PRODUCTS.filter(function(p){ return sg.indexOf(p.size)>-1; }).forEach(function(p){
      var qty=cart[p.id]||0;
      var c=document.createElement('div');
      c.className='ex-card'+(qty>0?' in':'');
      var exMedia = p.image
        ? '<img src="'+p.image+'" alt="'+p.name+'" loading="lazy">'
        : '<div class="ex-bottle" style="background:linear-gradient(180deg,'+p.color+',#333)"><span></span></div>';
      c.innerHTML='<div class="ex-art'+(p.image?' has-photo':'')+'">'+exMedia+'</div>'+
        '<span class="size-pill">'+p.size+'</span>'+
        '<h4 class="ex-name">'+p.name+'</h4>'+
        '<p class="ex-ingr">'+p.ingr+'</p>'+
        '<div class="ex-bot">'+priceHtml(p)+'<div class="ctrl"></div></div>';
      fillCtrl(c.querySelector('.ctrl'),p.id);
      exTrack.appendChild(c);
    });
  }
  var exTabs=document.querySelectorAll('.explore-tab');
  for(var t=0;t<exTabs.length;t++){
    exTabs[t].onclick=(function(tab){ return function(){
      exCat=tab.dataset.cat;
      for(var j=0;j<exTabs.length;j++){ exTabs[j].classList.toggle('on', exTabs[j]===tab); }
      if($('exTitle')) $('exTitle').textContent=EX_INFO[exCat].title;
      if($('exDesc'))  $('exDesc').textContent=EX_INFO[exCat].desc;
      renderExplore(); exTrack.scrollTo({left:0,behavior:'smooth'});
    }; })(exTabs[t]);
  }
  if($('exPrev')) $('exPrev').onclick=function(){ exTrack.scrollBy({left:-278,behavior:'smooth'}); };
  if($('exNext')) $('exNext').onclick=function(){ exTrack.scrollBy({left:278,behavior:'smooth'}); };

  /* ---------- FINDER (fill-in-the-blank) ---------- */
  if($('finderGo')) $('finderGo').onclick=function(){
    finderSize=$('fSize').value;
    var goal=$('fGoal').value;
    if(goal==='any'){
      var momentMap={morning:'energy',afternoon:'refresh',workout:'recovery',everyday:'all'};
      goal=momentMap[$('fMoment').value]||'all';
    }
    activeGoal = goal==='any' ? 'all' : goal;
    setBuildMode('goal');
    $('builder').scrollIntoView({behavior:'smooth'});
  };

  /* ---------- SUMMARY ---------- */
  /* Real Shopify-calculated total for the active mode (subPrice/oncePrice
     sums) — sub/disc are only for the "list price" vs "you pay" display,
     never used to compute the amount that's actually added to cart. */
  function totals(){
    var items=0, sub=0, total=0;
    for(var id in cart){
      var p=byId(id); if(!p) continue;
      items+=cart[id];
      sub+=p.price*cart[id];
      total+=unitPrice(p)*cart[id];
    }
    return {items:items, sub:sub, disc:sub-total, total:total};
  }
  function renderSummary(){
    var tt=totals();
    var cl=$('cartList');
    if(cl){
      var ids=Object.keys(cart);
      if(!ids.length){ cl.innerHTML='<div class="cart-empty">Your box is empty — start adding on the left.</div>'; }
      else{
        cl.innerHTML=ids.map(function(id){ var p=byId(id);
          return '<div class="cart-row"><span><b>'+cart[id]+'×</b> '+p.name+' <small>('+p.size+')</small></span><span>$'+(unitPrice(p)*cart[id]).toFixed(2)+'</span></div>';
        }).join('');
      }
    }
    if($('tItems')) $('tItems').textContent=tt.items;
    if($('tSub'))   $('tSub').textContent='$'+tt.sub.toFixed(2);
    if($('tDisc'))  $('tDisc').textContent='−$'+tt.disc.toFixed(2);
    if($('tTotal')) $('tTotal').textContent='$'+tt.total.toFixed(2);
    if($('discLabel')){
      var pct = tt.sub > 0 ? Math.round((tt.disc/tt.sub)*100) : 0;
      $('discLabel').textContent = mode==='sub' ? ('Subscribe & Save ('+pct+'%)') : ('Build-a-box ('+pct+'%)');
    }
    var pct=Math.min(100,(tt.items/MIN_ITEMS)*100);
    if($('progBar')) $('progBar').style.width=pct+'%';
    var remain=MIN_ITEMS-tt.items;
    if($('progTxt')) $('progTxt').textContent = remain>0?('Add '+remain+' more item'+(remain>1?'s':'')+' to check out.'):'Minimum reached — add as many as you like!';
    var co=$('checkout');
    if(co){
      if(tt.items>=MIN_ITEMS){ co.disabled=false; co.textContent='Checkout · $'+tt.total.toFixed(2); }
      else{ co.disabled=true; co.textContent='Add '+remain+' item'+(remain>1?'s':'')+' to continue'; }
    }
    if($('mTotal')) $('mTotal').textContent='$'+tt.total.toFixed(2);
    if($('mItems')) $('mItems').textContent = tt.items>=MIN_ITEMS?(tt.items+' items · ready'):(tt.items+' items · add '+remain+' to start');
  }

  var toggle=$('toggle');
  if(toggle) toggle.addEventListener('click', function(e){
    var b=e.target.closest('button'); if(!b) return;
    mode=b.dataset.mode;
    var bs=document.querySelectorAll('#toggle button');
    for(var i=0;i<bs.length;i++){ bs[i].classList.remove('on'); }
    b.classList.add('on');
    /* re-render cards too — their price display depends on mode */
    renderGrid(); renderExplore(); renderSummary();
  });

  /* ============================================================
     CHECKOUT — plain Shopify cart, real selling plans
     ------------------------------------------------------------
     No bundle handoff, no Recharge-specific API. Every product in
     cart{id:qty} already carries its own REAL selling_plan id — the
     subscription one (20%-ish, whatever Recharge has configured) if
     mode is 'sub', the one-time discounted one if mode is 'once' —
     both read straight from Shopify's variant data (see
     lj-routine-builder.liquid). We just add each as a normal Shopify
     cart line via the native Ajax Cart API and go to /checkout;
     Shopify + Recharge take it from there.
     ============================================================ */
  function buildCartItems(){
    return Object.keys(cart).map(function(id){
      var p = byId(id);
      var planId = planIdFor(p);
      var item = { id: p.variantId, quantity: cart[id] };
      if (planId) { item.selling_plan = planId; }
      return item;
    });
  }
  if($('checkout')) $('checkout').onclick=function(){
    var co = $('checkout');
    var items = buildCartItems();
    var restoreText = co.textContent;
    co.disabled = true;
    co.textContent = 'Adding to cart…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function(res){
        if (!res.ok) { return res.json().then(function(err){ throw err; }); }
        return res.json();
      })
      .then(function(data){
        if (typeof CFG.onCheckout === 'function') { CFG.onCheckout({ mode: mode, items: items, cart: cart, response: data }); }
        window.location.href = '/checkout';
      })
      .catch(function(err){
        console.error('Add to cart failed:', err);
        co.disabled = false;
        co.textContent = restoreText;
        var msg = (err && (err.description || err.message)) || 'Please try again.';
        alert('Something went wrong adding your box to cart.\n\n' + msg);
      });
  };

  /* mobile sticky bar button just scrolls to the builder */
  if($('mBtn')) $('mBtn').onclick=function(){ $('builder').scrollIntoView({behavior:'smooth'}); };

  /* ---------- INIT ---------- */
  renderGoals(); renderGrid(); renderExplore(); renderSummary();
  window.LivingJuiceRoutine = { getCart:function(){return cart;}, buildCartItems:buildCartItems };
})();
